export const WEBIEW_MESSAGE = {
  NEW_STARTUP: 'NEW_STARTUP',
  NEW_FUND: 'NEW_FUND',
  SET_EMBED: 'SET_EMBED',
  OPEN_POPUP: 'OPEN_POPUP',
  CLOSE_POPUP: 'CLOSE_POPUP',
};
